import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/20390772/pexels-photo-20390772.jpeg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 lg:pt-40 pb-20 lg:pb-28 overflow-hidden bg-white"
    >
      {/* Decorative left rail */}
      <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-neutral-200 to-transparent hidden lg:block" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Copy column */}
          <div className="lg:col-span-7">
            <div className="reveal eyebrow mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-[#E97906]" />
              Nobleza Corporativa Sagitta
            </div>

            <h1 className="reveal font-serif-display text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] leading-[0.95] tracking-tight text-neutral-950">
              Arquitectura legal,{" "}
              <span className="italic font-medium text-[#E97906]">
                ingeniería
              </span>{" "}
              contable.
            </h1>

            <p className="reveal mt-8 max-w-xl text-lg text-neutral-600 leading-relaxed">
              En Nobleza Corporativa Sagitta transformamos la complejidad
              normativa en ventajas competitivas para empresas y profesionales,
              mediante consultorías técnicas y auditorías de precisión.
            </p>

            <div className="reveal mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <a
                href="#contacto"
                data-testid="hero-cta-primary"
                className="btn-shine inline-flex items-center gap-3 bg-[#0A0A0A] text-white px-7 py-4 text-sm tracking-wider uppercase font-semibold hover:bg-[#E97906] transition-colors duration-300"
              >
                Contáctanos
                <ArrowRight size={18} />
              </a>
              <a
                href="#servicios"
                data-testid="hero-cta-secondary"
                className="link-underline text-sm font-semibold tracking-[0.18em] uppercase text-neutral-900"
              >
                Conoce nuestros servicios
              </a>
            </div>

            {/* Trust micro-row removed per user request */}
          </div>

          {/* Visual column */}
          <div className="lg:col-span-5 relative">
            <div className="relative reveal">
              <div className="absolute -inset-3 border border-[#E97906]/40 translate-x-4 translate-y-4 hidden md:block" />
              <div className="relative overflow-hidden bg-neutral-900 aspect-[4/5] floaty">
                <img
                  src={HERO_IMG}
                  alt="Sagitta Corporativo - despacho boutique"
                  className="w-full h-full object-cover opacity-95"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                <div
                  className="absolute bottom-6 left-6 right-6 text-white"
                  style={{ textShadow: "0 2px 18px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.9)" }}
                >
                  <div className="eyebrow text-white mb-2">
                    Noblesse Oblige
                  </div>
                  <p className="font-serif-display text-lg leading-snug">
                    Un compromiso inquebrantable con la rectitud, la protección
                    jurídica y la transparencia financiera.
                  </p>
                </div>
              </div>

              {/* Floating badges removed per user request */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
